import moment from 'moment-timezone';
import React, {useMemo} from 'react';

import {brandConfig, STRINGS} from '../../libs/ui/src';
import {Plans} from '../../libs/types/src';
import UpgradeButton from './UpgradeButtons';
import getLogo from '../../utils/getLogo';

import './Logo.scss';
import {InternalAnalyticsService} from '../../services';

const env = process.env.NX_PUBLIC_ENV || 'production';

const getDaysLeft = (trialEndDate: string) => {
  if (!trialEndDate) {
    return 0;
  }
  return moment.utc(trialEndDate).diff(moment(), 'days');
};

const getClientType = client => {
  let type = client.type;
  if (client.type === Plans.STARTER && client.signature_enabled) {
    type = 'Freemium';
  } else if (client.type === Plans.TRIAL && !client.subscription_account_id) {
    type = null;
  } else if (client.type === Plans.TRIAL && client.subscription_account_id) {
    type = client.awaiting_subscription_activation ? 'Expired Trial' : 'Cancelled';
  } else if ((client.type === Plans.STARTER || client.type === Plans.CORE || client.type === Plans.FREE) && client.trial_active) {
    type = 'Active Trial';
  } else if (client.type === Plans.CORE) {
    type = 'Core';
  } else if (client.type === Plans.FREE) {
    type = 'Free';
  } else if (client.type === Plans.STARTER) {
    type = brandConfig.isGx ? 'Accelerate' : 'Startup';
  }
  return type ? ` [${type}]` : '';
};

export const Logo = ({
  client,
  isAdmin,
  activateRegularPlan,
  activateRegularPlanGx,
  activatePlanFromTrial,
  info,
}: any) => {
  let versionText = isAdmin ? client.app_version : '';
  versionText += env !== 'production' ? ` ${env}` : '';
  versionText += getClientType(client);
  versionText += client && isAdmin ? ' [admin mode]' : '';
  const daysLeft = useMemo(() => getDaysLeft(client.trial_end_date), [client.trial_end_date]);

  const onDemoSubmit = () =>
    InternalAnalyticsService.sendEvent({event_type: 'demo_scheduled', code: ''})

  return (
    <div className="logo">
      <img src={getLogo()} className="logo__img" alt="logo" />
      <div className="version">
        <div className="text-primary text-smaller">{versionText}</div>
        <div>
          <UpgradeButton
            client={client}
            activateRegularPlan={activateRegularPlan}
            onDemoSubmit={onDemoSubmit}
            activateRegularPlanGx={activateRegularPlanGx}
            activatePlanFromTrial={activatePlanFromTrial}
            info={info}
          />
          {client && client.type === Plans.ON_HOLD && (
            <span className="trial-days">{STRINGS.info_subscription_onhold}</span>
          )}
          {client &&
            (client.type === Plans.STARTER || client.type === Plans.CORE || client.type === Plans.FREE) &&
            client.trial_active && (
              <span className="trial-days">{`You have ${daysLeft} days left of your trial.`}</span>
            )}
        </div>
      </div>
    </div>
  );
};
